import FormGroup from '@shared/ui/forms/display/FormGroup';

export default function FormSum({ label, text }) {
  return (
    <FormGroup label={label}>
      <p
        className="title-h3r expected-amount"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </FormGroup>
  );
}
